import { schema } from 'normalizr';

export const ENTITY_NAME = 'routeStagePoints';

export default new schema.Entity(ENTITY_NAME);
